/* eslint-disable prettier/prettier */
import * as React from "react";
import { Grid, Switch } from "@mui/material";
import ReportOverview from "./ReportOverview";
import ReportAmbulatory from "./ReportAmbulatory";
import { AuthenticationContext } from "../../Context";
import { useParams } from "react-router-dom";
import { useSwipeable } from "react-swipeable";
import { getHeaders } from "../../utils/HeaderHelper";
import { useGetPatientInfo } from "../../hooks/patients/useGetPatientInfo";
import { Stack } from "@mui/system";

const CgmReport = () => {
  const { id: patientId } = useParams();
  const authSettings = React.useContext(AuthenticationContext);
  const csrfToken = authSettings.csrfToken;
  const userRole = authSettings.userRole;
  const [cgmActive, setCgmActive] = React.useState(false);
  const { patient } = useGetPatientInfo(patientId, csrfToken);
  const cgmPresent = patient?.["cgm_present?"] ?? patient?.cgm_present ?? false;

  const swipeHandlers = useSwipeable({
    onSwipedLeft: () => (window.location.href = "/?menu=false"),
    onSwipedRight: () => (window.location.href = "/my-labs"),
  });

  React.useEffect(() => {
    if (patient != null) setCgmActive(Boolean(patient?.cgm_enabled));
  }, [patient]);

  const handleCgmActive = () => {
    if (!patientId) return;

    const nextActive = !cgmActive;
    setCgmActive(nextActive);

    const url = `/patients/${patientId}/toggle_cgm`;
    fetch(url, {
      method: "PATCH",
      headers: getHeaders(csrfToken),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.success === false) {
          setCgmActive((prev) => !prev);
          alert(result.error ?? "Failed to update CGM status");
        } else {
          setCgmActive(Boolean(result?.resource?.cgm_enabled));
        }
      })
      .catch((error) => {
        setCgmActive((prev) => !prev);
        console.error(error);
      });
  };

  return (
    <>
      {cgmPresent ? (
        <Grid className="cgm-report-container" {...swipeHandlers}>
          <Grid container spacing={3} className="main-report-container">
            <Grid
              item
              xs={12}
              lg={userRole == "patient" ? 12 : 4}
              paddingLeft={"0 !important"}
              paddingTop={"6px !important"}
            >
              <ReportOverview csrfToken={csrfToken} />
            </Grid>
            <Grid
              item
              xs={12}
              lg={userRole == "patient" ? 12 : 8}
              pt={"0px !important"}
              pb={"30px"}
            >
              <ReportAmbulatory
                csrfToken={csrfToken}
                cgmActive={cgmActive}
                handleCgmActive={handleCgmActive}
              />
            </Grid>
          </Grid>
        </Grid>
      ) : (
        <Grid container className="panel-container">
          <Grid item xs={12} className="box-header">
            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              paddingX={3}
              alignItems={"center"}
              display={"flex"}
            >
              <Grid item>
                <h3>Patient CGM</h3>
              </Grid>
              <Stack direction={"row"} alignItems={"center"} display={"flex"}>
                <Switch
                  checked={cgmActive}
                  onChange={handleCgmActive}
                  color="primary"
                  sx={{ alignSelf: "center" }}
                />
                <p>CGM Patient Status: {cgmActive ? "Active" : "Inactive"}</p>
              </Stack>
            </Stack>
          </Grid>
          <Grid
            item
            className="tabs-container"
            xs={12}
            sx={{ bgcolor: "#EFE9E8", padding: 2 }}
          >
            <Grid
              item
              xs={12}
              className="box-header"
              px={5}
              py={3}
              borderRadius={"4px"}
            >
              <Stack
                direction={"row"}
                justifyContent={"center"}
                width={"100%"}
                spacing={5}
                alignItems={"center"}
              >
                <p>
                  {!cgmActive
                    ? "You can add the CGM tag to this patient by interacting with the toggle above!"
                    : "This patient is assigned the CGM tag. However, this patient has yet to input any CGM data. We will update this page once data is received."}
                </p>
              </Stack>
            </Grid>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default CgmReport;
